<template>
  <div
    v-if="filteredActions.length > 0"
    class="actions-tray-drawer"
  >
    <v-navigation-drawer
     @touchstart.native.stop
     @touchend.native.stop
     @touchmove.native.stop
     :value="drawer"
     height="100%"
     temporary
     right
     fixed>
      <v-card class="actions-tray-drawer__card primary">
        <v-card-media class="actions-tray-drawer__card-media px-0">
          <v-container class="py-2 pl-2">
            <v-layout>
              <v-btn icon dark class="mr-4" @click.native="$emit('update:nav', false)"><v-icon>arrow_back</v-icon></v-btn>
              <v-flex d-flex xs12 style="align-items: center; overflow-wrap: anywhere">
                <span class="headline white--text">{{ title }}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-media>
      </v-card>
      <v-list>
        <component
          v-for="(action, index) in filteredActions"
          :key="index"
          :is="action.component"
          v-bind="action.props"
          list
        />
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty'
import Mixin from './ActionsTray.js'

export default {
  name: 'ActionsTrayDrawer',
  mixins: [Mixin],
  props: {
    drawer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title () {
      return !isEmpty(this.$store.state.file.record)
        ? this.$store.state.file.record.name
        : this.$tf(this.$store.state.nav.navRoot.translate)
    }
  }
}
</script>

<style lang="scss" scoped>
  .actions-tray-drawer {
    &__card {
      height: auto !important;
    }

    &__card-media {
      padding: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/actions-tray/ActionsTrayDrawer.vue